import { render, staticRenderFns } from "./WorkflowFormTemplateStakeholderUserProvider.vue?vue&type=template&id=7e41a434&"
import script from "./WorkflowFormTemplateStakeholderUserProvider.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormTemplateStakeholderUserProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports